/** Shared business contact details. */
const CONTACT_PHONE = '37379398167'

/** `tel:` href target for the business phone. */
export const CONTACT_PHONE_TEL = `+${CONTACT_PHONE}`

/** Build a WhatsApp deep link with a pre-filled message. */
export function buildWhatsappUrl(text: string): string {
  return `https://wa.me/${CONTACT_PHONE}?text=${encodeURIComponent(text)}`
}
